import { render, staticRenderFns } from "./SiteVersions.vue?vue&type=template&id=53e516d2&"
import script from "./SiteVersions.vue?vue&type=script&lang=js&"
export * from "./SiteVersions.vue?vue&type=script&lang=js&"
import style0 from "./SiteVersions.vue?vue&type=style&index=0&id=53e516d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports